import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer } from "lucide-react";

export const ReferralQr = ({ link, id, name }) => {
  const ref = useRef(null);
  const canvas = () => ref.current?.querySelector("canvas");
  const download = () => {
    const a = document.createElement("a");
    a.href = canvas().toDataURL("image/png");
    a.download = `BMI-referral-${id}.png`;
    a.click();
  };
  const print = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<html><head><title>BMI SP GROUP referral – ${id}</title></head><body style="font-family:sans-serif;text-align:center;padding:40px">
      <h1 style="margin:0">BMI SP GROUP</h1><p style="margin:4px 0 24px;color:#555">Clean Home · Healthy Life</p>
      <img src="${canvas().toDataURL("image/png")}" style="width:320px;height:320px" />
      <h2 style="margin:20px 0 4px">${name}</h2><p style="margin:0;font-size:20px;font-weight:bold">Distributor ID: ${id}</p>
      <p style="margin-top:16px;color:#555">Scan to join free as a distributor or buy genuine SP Quick Wash products</p>
      <p style="font-size:12px;color:#777;word-break:break-all">${link}</p>
      <script>window.onload=()=>{window.print()}</script></body></html>`);
    w.document.close();
  };
  return (
    <div className="flex flex-wrap items-center gap-5 border-t border-slate-100 pt-4" data-testid="member-referral-qr">
      <div ref={ref} className="rounded-xl border border-slate-200 bg-white p-3"><QRCodeCanvas value={link} size={140} level="M" marginSize={1} /></div>
      <div className="space-y-2">
        <p className="text-sm text-slate-600">Let people scan this QR code to open your referral link.</p>
        <div className="flex flex-wrap gap-2">
          <button onClick={print} className="inline-flex items-center gap-1.5 rounded-full bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700" data-testid="member-qr-print"><Printer className="h-4 w-4" /> Print QR card</button>
          <button onClick={download} className="inline-flex items-center gap-1.5 rounded-full border border-slate-900 px-4 py-2 text-sm font-semibold hover:bg-slate-900 hover:text-white" data-testid="member-qr-download"><Download className="h-4 w-4" /> Download PNG</button>
        </div>
      </div>
    </div>
  );
};
